<div class="column-wrapper">
  <button
    ene-button
    [icon]="$any(columnConfig).icon ?? 'ec_mplayer_dots-vertical'"
    [color]="columnConfig.actionColor ?? 'accent'"
    [matMenuTriggerFor]="columnMenu"
    [disabled]="disabled($any(columnConfig), row)"
  ></button>
</div>
<mat-menu
  class="menu-column__mat-menu"
  #columnMenu="matMenu"
  xPosition="before"
  [classList]="columnConfig.classList"
>
  <ng-container *ngFor="let item of options($any(columnConfig), row); trackBy: trackByValue">
    <button
      mat-menu-item
      [disabled]="item.disabled"
      (click)="onTableAction({ id: item.value, type: 'click', row: context.row })"
    >
      <tpm-icon *ngIf="item.icon" [icon]="item.icon"></tpm-icon>
      <span>{{ item.label | translate }}</span>
    </button>
  </ng-container>
</mat-menu>
